import { render, staticRenderFns } from "./SelfServicePageCustom.vue?vue&type=template&id=0bc23212&"
import script from "./SelfServicePageCustom.vue?vue&type=script&lang=js&"
export * from "./SelfServicePageCustom.vue?vue&type=script&lang=js&"
import style0 from "./SelfServicePageCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports